/** Keep zoom gestures inside Aquaduck without consuming app gesture handlers. */
export function preventPageZoom(target: Window) {
  const options = { capture: true, passive: false };
  const prevent = (event: Event) => {
    if (event.cancelable) event.preventDefault();
  };
  const wheel = (event: WheelEvent) => {
    // Trackpad pinches are ctrl+wheel in Chromium/Firefox. Ordinary scrolling
    // and browser keyboard/menu zoom remain available.
    if (event.ctrlKey) prevent(event);
  };
  // Capture runs even when a node stops bubbling before reaching the canvas.
  // Do not stop propagation: the canvas and node controls still own their zoom.
  target.addEventListener("wheel", wheel, options);
  const gestures = ["gesturestart", "gesturechange", "gestureend"] as const;
  for (const type of gestures) target.addEventListener(type, prevent, options);
  return () => {
    target.removeEventListener("wheel", wheel, options);
    for (const type of gestures) target.removeEventListener(type, prevent, options);
  };
}
